import { EChartsOption } from 'echarts';
import { capitalizeFirstLetter, getStyleProp, smartWrap, telemetryStyles, toFixedIfNecessary } from 'ngx-core-services';

import { EnergySeries } from './energy-data-overview.model';

export const buildEnergyPieChart = (series: EnergySeries[], totalizer: EnergySeries): EChartsOption => ({
  title: {
    text: `{a|${capitalizeFirstLetter(smartWrap(totalizer.name, 12))}}\n{e|}\n{b|${toFixedIfNecessary(`${totalizer.value}`, 2)} kWh}`,
    left: 'center',
    top: 'center',
    textStyle: {
      rich: {
        a: {
          padding: 2,
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          borderRadius: 4,
          align: 'center',
          fontSize: 14,
        },
        e: {
          lineHeight: 5,
        },
        b: {
          padding: 2,
          fontWeight: 'bold',
          fontSize: 14,
          backgroundColor: 'rgba(255, 255, 255, 0.5)',
          borderRadius: 4,
        },
      },
    }
  },
  grid: {
    show: false,
    top: '10px',
    bottom: '10px',
    left: '10px',
    right: '10px',
  },
  tooltip: {
    confine: true,
    trigger: 'item',
    formatter: (params: any): string => {
      const kwh = toFixedIfNecessary(`${params.data.value}`, 2);
      const percentage = params.data.percentage !== undefined
        ? ` (${toFixedIfNecessary(`${params.data.percentage}`, 2)}%)`
        : '';

      const detailsTemplate = `
        <div class="fx-row fx-align-center fx-justify-between tw-text-sm text-grey-400 p-1">
          <div class="tw-font-medium text-style-italic mr-5 fx-row">
            <div class="s-4 rounded mr-3" style="background: ${params.color}"></div>
            ${capitalizeFirstLetter(params.data.name)}
          </div>
          <div class="tw-font-normal">
            ${kwh} kWh${percentage}
          </div>
        </div>
      `;

      return `${detailsTemplate}`;
    },
    backgroundColor: getStyleProp('--white-100'),
    borderColor: getStyleProp('--grey-300'),
    shadowBlur: 0,
    shadowOffsetX: 0,
    shadowOffsetY: 0,
    borderRadius: 4,
    padding: 0,
    textStyle: { color: getStyleProp('--white') },
  },
  series: [
    {
      type: 'pie',
      startAngle: 90,
      tooltip: {
        trigger: 'item',
      },
      radius: ['40%', '70%'],
      avoidLabelOverlap: true,
      itemStyle: {
        borderColor: getStyleProp('--white'),
        borderWidth: 2,
      },
      label: {
        show: true,
        formatter: (d: any) => `{a|${capitalizeFirstLetter(smartWrap(d.name, 8))}}\n{b|${toFixedIfNecessary(d?.data?.percentage !== undefined ? `${d.data.percentage}` : '', 2)} %}`,
        rich: {
          a: {
            align: 'center',
            fontSize: 14,
            color: getStyleProp('--grey-300'),
          },
          b: {
            padding: [5, 0, 0, 0],
            fontWeight: 'bold',
            fontSize: 14,
            color: getStyleProp('--grey-400'),
          },
        },
      },
      data: series.map(({ name: seriesName, value, percentage }) => {
        const { name, scssColor, offsetCenter } = telemetryStyles(seriesName);
        return {
          name,
          value,
          percentage,
          itemStyle: {
            color: getStyleProp(scssColor as string),
          },
          title: {
            offsetCenter,
          },
        };
      }),
    },
  ],
});
